import { roleHelpers } from '@/services/utils';
import splitBillingService from '@/services/splitBillingService';
angular.module('leanlaw').controller('MattersNextCtrl', ['$scope', '$http', '$stateParams', '$q', 'matterFilterService', 'leanLawAuth', 'userService', '$state', 'accountingService', 'exportJson', 'alerts', function ($scope, $http, $stateParams, $q, matterFilterService, leanLawAuth, userService, $state, accountingService, exportJson, alerts) {
  $scope.vm = {
    me: undefined
  };
  $scope.state = $state;
  $scope.currentPage = $stateParams.page || 1;
  $scope._ = _;
  $scope.loading = true;

  // Cancellation token for matters/table API requests
  let tableRequestCancellation = $q.defer();
  $scope.goneLegend = false;
  $scope.showConnectionStatuse = false;
  $scope.validating = false;
  $scope.matters = [];
  $scope.mattersToExport = [];
  $scope.loadPagedMatters = loadPagedMatters;
  $scope.domain = `${leanLawAuth.domain}/v1`;
  $scope.pageOptions = [{
    text: 10,
    value: 10
  }, {
    text: 20,
    value: 20
  }, {
    text: 50,
    value: 50
  }];
  $scope.matterFilter = matterFilterService.state;
  $scope.filter = {
    scopeAccount: null,
    originating: $scope.matterFilter.originating || false,
    primary: $scope.matterFilter.primary,
    involved: true,
    reviewer: false,
    search: '',
    archived: false,
    quickBooksStatuses: null,
    checkQuickbooks: false,
    qbConnectionType: 'any',
    customFields: {} // { fieldId: optionId }
  };
  $scope.customFieldFilters = [];
  $scope.paging = {
    currentPage: 1,
    itemsPerPage: 20,
    orderBy: 'matterId',
    sortAscending: true,
    itemCount: 0
  };
  $scope.filterChanged = function () {
    $scope.loadPagedMatters();
  };
  $scope.accounting = {
    connected: false
  };
  $scope.export = exportMatters;
  $scope.pageTable = function (newPageNumber) {
    $scope.paging.currentPage = newPageNumber;
    loadPagedMatters();
  };
  $scope.print = function () {
    window.print();
  };
  accountingService.verify().then(() => {
    $scope.accounting.connected = true;
  }).catch(() => {
    $scope.accounting.connected = false;
  });
  $scope.showMatter = function (matter, next = false) {
    if (next) {
      $state.go('.client.matter', {
        id: matter.clientId,
        matterId: matter.id
      });
    } else {
      $state.go('.matter', {
        id: matter.id
      });
    }
  };
  $scope.activate = function (matter, active) {
    const term = $scope.vm.me.terms.matter;

    // Check if this is a secondary split billing matter and restrict both archive and restore
    if (matter.isSecondarySplitMatter) {
      const action = active ? 'Restore' : 'Archive';
      splitBillingService.showActionRestrictionIfNeeded(matter.id, term, action);
      return;
    }
    if (!active) {
      let message = `<h4>Do you want to archive this ${term}?</h4><p>Archiving the ${term} will hide it from all users and hide any unbilled time or expenses from some pages. You can easily restore the ${term} from here if you need it again.</p>`;
      bootbox.confirm(message, result => {
        if (result) {
          performActivation(matter, false, `The ${term} was archived. You can find it on the lists by selecting 'Show Archived'.`);
        }
      });
    } else {
      performActivation(matter, true, `The ${term} was restored.`);
    }
  };
  function performActivation(matter, active, successMessage) {
    const path = `${$scope.domain}/matters/${matter.id}`;
    const payload = {
      active
    };
    $http.put(path, payload).then(() => {
      if (successMessage) {
        alerts.success(successMessage);
      }
      $scope.filterChanged();
    }).catch(err => {
      console.error('Error updating matter status:', err);
      alerts.error(err);
    });
  }
  $scope.billingTypeDisplay = function (billingType) {
    if (billingType === 'hours') {
      return 'Hourly';
    }
    if (billingType === 'none') {
      return 'Pro Bono';
    }
    if (billingType === 'fixed') {
      return 'Fixed Fee';
    }
    if (billingType === 'contingency') {
      return 'Contingency';
    }
    if (billingType === 'internal') {
      return 'Internal';
    }
    return '';
  };
  loadPage();
  async function loadPage() {
    const me = await userService.me();
    $scope.vm.me = me;
    $scope.integration = me.company.integration;
    $scope.showReviewer = me.company.settings.workflow.reviewer;
    $scope.selectedAccount = {
      id: me.id
    };
    // Copied from timeentries.ctrl.js
    if (!roleHelpers.isOperatorOrAccountantRole(me.role)) {
      $scope.filter.account = me;
    }
    if (me.settings.selectedAccount) {
      $scope.selectedAccount = {
        id: me.settings.selectedAccount.id
      };
    }
    if (me.features.customFieldFilters) {
      loadCustomFields();
    }
    loadAccounts();
  }
  function loadCustomFields() {
    const path = `${$scope.domain}/customfields`;
    $http.get(path).then(response => {
      const fields = response.data || [];
      const customFields = Array.isArray(fields) ? fields : fields.customFields || [];
      // Filter for matter dropdown/enum fields that are active
      $scope.customFieldFilters = customFields.filter(f => f.entity == 'matter' && f.type === 'enum' && f.active);
    }).catch(err => {
      console.error('Error loading custom fields:', err);
    });
  }
  $scope.customFieldChanged = function () {
    loadPagedMatters();
  };
  function loadPagedMatters() {
    $scope.loading = true;
    updateMatterFilter();
    const query = buildQuery(false);
    fetchPagedMatters(query).then(response => {
      // Only update if response exists (not cancelled)
      if (response && response.data) {
        const matters = response.data.items;
        $scope.paging.itemCount = response.data.count;
        $scope.references = matters?.some(x => x.reference);
        $scope.matters = matters;
        if ($scope.filter.checkQuickbooks) {
          $scope.QBOClients = $scope.matters;
          $scope.showConnectionStatuse = true;
          $scope.validating = false;
        } else {
          $scope.QBOClients = [];
        }
      }
      $scope.loading = false;
    }).catch(error => {
      // Ignore cancellation errors; show a safe message for real failures.
      if (error.status !== -1) {
        alerts.error('Unable to load matters right now. Please try again.');
      }
      $scope.loading = false;
    });
  }
  $scope.scopeChange = function (prop) {
    loadPagedMatters();
  };
  function fetchPagedMatters(query) {
    const path = `${$scope.domain}/matters/table`;

    // Abort any pending request by resolving the cancellation token
    tableRequestCancellation.resolve();

    // Create a new cancellation token for this request
    tableRequestCancellation = $q.defer();
    const timeoutPromise = tableRequestCancellation.promise;
    return $http.get(path, {
      params: query,
      timeout: timeoutPromise
    }).catch(error => {
      // Handle cancellation gracefully - don't treat as error
      if (error.status === -1 && error.config?.timeout === timeoutPromise) {
        // Request was cancelled, ignore silently
        return $q.when();
      }
      // Re-throw other errors
      return $q.reject(error);
    });
  }
  function buildQuery(forExport) {
    const limit = forExport ? $scope.paging.itemCount : $scope.paging.itemsPerPage;
    const scopeAccount = $scope.filter.scopeAccount ? $scope.filter.scopeAccount.id : null;
    if (!scopeAccount) {
      $scope.filter.involved = false;
      $scope.filter.originating = false;
      $scope.filter.primary = false;
    } else {
      $scope.filter.involved = true;
    }
    const query = {
      limit,
      offset: $scope.paging.currentPage - 1,
      sortAscending: $scope.paging.sortAscending,
      orderBy: $scope.paging.orderBy,
      scopeAccount,
      archived: $scope.filter.archived,
      originating: $scope.filter.originating,
      involved: $scope.filter.involved,
      primary: $scope.filter.primary,
      reviewer: $scope.filter.reviewer,
      search: $scope.filter.search,
      checkQuickbooks: $scope.filter.checkQuickbooks,
      qbConnectionType: $scope.filter.qbConnectionType
    };
    if (query.offset > 0) {
      query.knownCount = $scope.paging.itemCount;
    } else {
      query.knownCount = null;
    }

    // Add custom field filters
    const customFieldEntries = Object.entries($scope.filter.customFields || {});
    customFieldEntries.forEach(([fieldId, optionId], index) => {
      // Skip if empty string, null, or undefined (deselected)
      if (optionId && optionId !== '') {
        query[`mattercustomfield[${index}].fieldid`] = fieldId;
        // Only include optionid if not filtering for "Not assigned"
        if (optionId !== 'NOT_ASSIGNED') {
          query[`mattercustomfield[${index}].optionid`] = optionId;
        }
      }
    });
    return query;
  }
  function loadAccounts() {
    $scope.accountsLoaded = false;
    userService.list().then(accounts => {
      let scopeAccountIdToFind = null;
      if (!roleHelpers.isOperatorOrAccountantRole($scope.vm.me.role)) {
        scopeAccountIdToFind = $scope.matterFilter.scopeAccount ? $scope.matterFilter.scopeAccount.id : $scope.vm.me.id;
      } else if ($scope.matterFilter.scopeAccount) {
        scopeAccountIdToFind = $scope.matterFilter.scopeAccount.id;
      }
      $scope.accounts = accounts;
      $scope.filter.scopeAccount = scopeAccountIdToFind ? $scope.accounts.find(x => x.id === scopeAccountIdToFind) : null;
      $scope.accountsLoaded = true;
      $scope.filterLoaded();
      loadPagedMatters();
    }).catch(ex => {
      console.log(ex);
    });
  }
  $scope.changeSort = function (sortField) {
    if ($scope.paging.orderBy === sortField) {
      $scope.paging.sortAscending = !$scope.paging.sortAscending;
    } else {
      $scope.paging.orderBy = sortField;
      $scope.paging.sortAscending = true;
    }
    loadPagedMatters();
  };
  $scope.filterLoaded = function () {
    $scope.filter.loaded = true;
  };
  $scope.showConnectionStatusesFilter = function () {
    $scope.validating = true;
    $scope.filter.checkQuickbooks = true;
    loadPagedMatters();
  };
  $scope.changeConnectionStatuses = function () {
    $scope.filter.qbConnectionType = $scope.filter.quickBooksStatuses ? $scope.filter.quickBooksStatuses : 'any';
    loadPagedMatters();
  };
  $scope.editClient = function (matter) {
    $state.go('.client', {
      id: matter.clientId
    });
  };
  $scope.redirectToCreate = function () {
    if (($scope.vm.me.features?.timeEntriesTab ?? false) && ($scope.vm.me.settings?.enableNewTimeEntry ?? false)) {
      $state.go('matters-next.matter2', {
        methodOverride: 'matter page'
      });
      return;
    }
    $state.go('.newMatter', {
      methodOverride: 'matter page'
    });
  };
  $scope.edit = function (matter) {
    $state.go('.client.matter', {
      id: matter.clientId,
      matterId: matter.id
    });
  };
  $scope.quickbooks = async function (matter) {
    await accountingService.verify(true);
    $state.go('.connect', {
      matterId: matter.id
    });
  };
  $scope.trust = async function (matter) {
    $state.go('.trust', {
      matterId: matter.id
    });
  };
  function updateMatterFilter() {
    $scope.matterFilter.scopeAccount = $scope.filter.scopeAccount;
    $scope.matterFilter.primary = $scope.filter.primary;
    $scope.matterFilter.originating = $scope.filter.originating;
  }
  function exportMatters() {
    const query = buildQuery(true);
    fetchPagedMatters(query).then(response => {
      $scope.mattersToExport = response.data.items;
      function makeRow(matter) {
        return {
          'Matter Id': matter.reference,
          Matter: matter.name,
          'Client Id': matter.clientReference,
          Client: matter.clientName,
          Responsible: matter.primaryName,
          'Last Activity': new Date(matter.updated).toNetworkDate(),
          Opened: new Date(matter.opened).toNetworkDate(),
          Billing: matter.billingType
        };
      }
      const items = [];
      $scope.mattersToExport.forEach(t => items.push(makeRow(t)));
      exportJson.downloadCsv(items, 'Matters');
    });
  }

  // Cleanup on scope destroy - abort any pending table requests
  $scope.$on('$destroy', () => {
    tableRequestCancellation.resolve();
  });
}]);